module.exports = __webpack_public_path__ + "static/img/bottom.054ba62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/bottom.png
// module id = 1UW6
// module chunks = 4